import { useCbhFlag } from "../../../FeatureFlags";
import { CbhFeatureFlag } from "../../../FeatureFlags/CbhFeatureFlag";

export function useTalkToRecruiterCopyText() {
  return useCbhFlag(CbhFeatureFlag.TALK_TO_RECRUITER_COPY, {
    defaultValue: {
      banner: {
        screening: "Talk to a Clipboard recruiter to unlock listings with instant interviews",
        screeningAction: "Start 20-min call",
        upskilling: "Complete your coaching call to unlock Instant Interviews",
        upskillingAction: "Schedule now",
      },
      id: "talk-to-recruiter",
      placementAction: {
        screening: "Talk to a Clipboard recruiter",
        screeningDescription: "This is a one-time call to apply to jobs and book interviews",
        upskilling: "Complete coaching session",
        upskillingDescription:
          "A 30 minute private coaching session about acing your interview. You'll need to complete this course to unlock instant interviews",
      },
    },
  });
}

export type TalkToRecruiterCopy = ReturnType<typeof useTalkToRecruiterCopyText>;
